import { modelListReducer } from '../../Pages/ModelList/ModelList.reducer';
import { runtimeHistoryReducer } from '../../Pages/RuntimeHistory/RuntimeHistory.reducer';
import { modelArchiveReducer } from '../../Pages/ModelArchive/ModelArchive.reducer';
import { inferenceReducer } from '../../Pages/Inference/Inference.reducer';
import { administrationReducer } from '../../Pages/Administration/Administration.reducer';

/**
 * Asynchronous reducer objects mapping
 */
const asyncReducersObjectMapping = {
  modelListReducer,
  runtimeHistoryReducer,
  modelArchiveReducer,
  inferenceReducer,
  administrationReducer,
};

export default asyncReducersObjectMapping;
